
import {Ng2ScrollableDirective} from "./ng2-scrollable.directive";
import {Ng2ScrollableModule} from "./ng2-scrollable.module";

export { Ng2ScrollableDirective, Ng2ScrollableModule };




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/strip-loader/lib?strip[]=debug,strip[]=console.log!./src/index.ts